$(function() {
    $(".job-listing-body").hide();
    $(".job-listing h2").click(function() {
        $(this).siblings(".job-listing-body").toggle();
    });
})